import catalogComponent from "./catalogComponent";
import sendEventsMixin from "@mixins/sendEventsMixin";

export default {
    mixins: [
        catalogComponent,
        sendEventsMixin
    ],
    props: {
        catalog_id: {
            type: Number,
        },
    },
    data: () => ({
        catalog: {},
        page: 1,
    }),
    computed: {
        categoryTitle: function () {
            let title = this.catalog.title;

            if (!title) {
                title = this.catalog.meta_title;
            }

            return title || 'Catalog';
        },
        productsQuery: function () {
            return {
                categories: this.categories,
                page: this.page,
                catalog_id: this.catalog_id,
            };
        },
        productApiUrl: function () {
            return '/api/v1/products/catalog';
        },
        catalogDescription: function () {
            return this.catalog.description || null;
        },
        queryPage() {
          return this.$route.query.page || null;
        }
    },
    methods: {
        loadCatalog: function () {
            axios.get(`/api/v1/catalog/${this.catalog_id}`)
                .then((r) => {
                    this.categories = r.data.categories || [];
                    this.availableFilters = this.whitelistFilters = this.flatFilterObject(r.data.filters);
                    this.catalog = r.data.catalog.data || {};
                    this.page = this.$route.query.page ? this.$route.query.page : 1;
                    this.updatingFiltersFromQuery = true;
                    this.updateProducts();
                    if (r.data.pagination) {
                        this.page = r.data.pagination.current_page;
                        this.total_pages = r.data.pagination.total_pages;
                    }
                    this.onCatalogLoaded(this.categoryTitle);
                }).then(() => {
                this.loading = false;
            })
        },
    },
}
